import Container from '@/landing/component/container/nogap'

import Head from "@helper/seo/head"

const PrivacyPolicy = () => {
  return (
    <Container>
      <Head
        title="BabyBoom | Privacy Policy"
        type="website"
        url="https://sellon.net/"
        siteName="Sellon Tech"
        image="/media/logo/main.png"
      />
      <div className='md: mx-6'>
        <h1 className='text-center text-3xl font-bold mb-10 lg: mt-16'>Privacy Policy</h1>
        <h3 className="mb-10 text-large text-center font-semibold">
          Welcome to BabyBoom Service! This Privacy Policy is designed to help you understand how we collect, use, disclose, and safeguard your personal information. By using our services, you agree to the terms outlined in this Privacy Policy.
        </h3>

        <div className='mb-5'>
          <strong>1. Information We Collect :</strong>
          <div className='ml-4'>
            <ul>
              <li>a. Personal Information :</li>
              <p className='ml-5'>When you register for our service, we may collect personal information such as your name, email address, gender.</p>
              <li>b. Payment Information :</li>
              <p className='ml-5'>We don't collect any payment information. Transactions can be done between user's wallet address.</p>
              <li>c. Device Information :</li>
              <p className='ml-5'>We don't collect any device information.</p>
              <li>d. Usage Data :</li>
              <p className='ml-5'>We collect information about how much transactions you made on our service.</p>
            </ul>
          </div>
        </div>

        <div className='mb-5'>
          <strong>2. How We Use Your Information :</strong>
          <div className='ml-5'>
            <ul>
              <li>a. Service Delivery :</li>
              <p className='ml-5'>We use your personal information to provide you with our services, process transactions, and deliver a personalized user experience.</p>
              <li>b. Communication :</li>
              <p className='ml-5'>We may use your contact information to communicate with you about our services, updates, and promotions.</p>
              <li>c. Analytics :</li>
              <p className='ml-5'>We analyze usage data to improve our services, enhance user experience, and optimize our platform's performance.</p>
              <li>d. Security :</li>
              <p className='ml-5'>Your information is crucial for the security of our platform. We use it to detect and prevent fraud, unauthorized ccess, and other security issues.</p>
            </ul>
          </div>
        </div>

        <div className='mb-5'>
          <strong>3. How We Share Your Information :</strong>
          <div className='ml-5'>
            <ul>
              <li>a. Other service Providers :</li>
              <p className='ml-5'>We don't share your information with others.</p>
              <li>b. Legal Compliance :</li>
              <p className='ml-5'>We may disclose your information to comply with legal obligations, enforce our policies, or respond to legal requests.</p>
              <li>c. Business Transactions :</li>
              <p className='ml-5'>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.</p>
            </ul>
          </div>
        </div>

        <div className='mb-5'>
          <strong>4. Your Choices :</strong>
          <div className='ml-5'>
            <ul>
              <li>a. Access and Correction :</li>
              <p className='ml-5'>You can review and update your personal information through your account settings.</p>
              <li>b. Opt-Out :</li>
              <p className='ml-5'>You can opt out of receiving promotional communications by following the instructions in our emails or contacting us directly.</p>
            </ul>
          </div>
        </div>

        <div className='mb-5'>
          <strong>5. Security :</strong>
          <div className='ml-5'>
            <p className="mb-3">
            We adopt encryption based security measures to protect your information from unauthorized access, disclosure, alteration, and destruction.
            </p>
          </div>
        </div>

        <div className='mb-5'>
          <strong>6. Changes to This Privacy Policy :</strong>
          <div className='ml-5'>
            <p className="mb-3">
            We may update this Privacy Policy periodically to reflect changes in our practices. We will notify you of any significant changes through our website or other communication channels.
            </p>
          </div>
        </div>

        <div className='mb-5'>
          <strong>7. Contact Us :</strong>
          <div className='ml-5'>
            <p className="mb-3">
            If you have any questions or concerns about this Privacy Policy, please contact us at [<span style={{textDecoration: 'underline', color: 'blue'}}>support@babyboomtoken.com</span>].
            </p>
          </div>
        </div>

        <p>By using BabyBoom Service, you agree to the terms outlined in this Privacy Policy. Thank you for trusting us with your information!</p>

      </div>
    </Container>
  );
};

export default PrivacyPolicy;
